module.exports = __webpack_public_path__ + "img/society-nefertiti-avatar.83c3a1e8.png";